<script lang="ts" setup>
    const props = defineProps<{
        blok: FachkreisLandingPageStoryblok;
    }>();

    const { lang } = useLanguage();
    const { t } = useI18n();

    const seoTitle = props.blok.AI_SEO?.title ?? '';
    const { isFachportal } = usePlatformMeta();

    const canonicalUrlAbsolute = useCanonicalUrl(props.blok.canonicalLink);

    useHead(() => ({
        title: `${
            (seoTitle && seoTitle.length > 0 ? `${seoTitle} | ` : '') +
            (isFachportal.value ? `${t('platform.prescriber')} | ` : '')
        }MEDICE Health Family`,
        htmlAttrs: {
            lang: lang.value
        },
        link: [{ rel: 'canonical', href: canonicalUrlAbsolute.value }]
    }));
</script>

<template>
    <div>
        <StickyWrapper />
        <StoryblokComponentWrapper
            v-if="props.blok.hero"
            :blok="props.blok.hero[0]"
        />

        <StoryblokComponentWrapper
            v-for="item in props.blok.body"
            :key="item._uid"
            :blok="item"
        />
    </div>
</template>
